<template>
  <LcButton
    :aria-label="$t('editor.pricedetails.open.arialabel')"
    class="editor-total-price text-primary-primary"
    :disabled="!playCount"
    no-padding
    size="medium"
    type="button"
    variant="tertiary"
    @click="emit('click')"
  >
    <span class="basket">
      <LcIcon :name="playCount ? 'shopping-card-filled' : 'shopping-card-empty'" />
      <LcCountBubble
        class="bubble"
        :count="playCount"
        :variant="hasPromoCode ? 'success' : 'info'"
      />
    </span>

    <span class="paragraph-bold">{{ total.toString() }}</span>
  </LcButton>
</template>

<script lang="ts" setup>
import type Money from '~~/models/Money'

type Emits = {
  (event: 'click'): void
}

type Props = {
  hasPromoCode?: boolean
  playCount: number
  total: Money
}

defineProps<Props>()
const emit = defineEmits<Emits>()
</script>

<style lang="scss" scoped>
.editor-total-price {
  padding: token('size/space/gap/none');

  /* stylelint-disable-next-line selector-class-pattern */
  :deep(.lc-button__label-bubble) {
    gap: token('size/space/gap/150');
  }

  /* stylelint-disable-next-line selector-class-pattern */
  :deep(.lc-button__content) {
    justify-content: start;
    min-width: 120px;
  }

  .basket {
    position: relative;
    display: inline-flex;

    .bubble {
      top: -1 * token('size/050');
      right: -1 * token('size/075');
    }
  }
}
</style>
